import { Tag } from "@msuite/ui/tag";
import { useTranslation } from "@msuite/ui/localization";
import { calculateTimeBySeconds, getCalculatedTimeEasyString } from "@msuite/utils/date";
import type { Nullable } from "@msuite/utils/types";

/** Props Interface */
interface AttendanceCardDurationProps {
	seconds: Nullable<number>;
}

/**
 * What the attendance came to, which is the one figure on this card nobody has to work out.
 *
 * `seconds` is the database's own generated column, so it is the same arithmetic every other
 * reader of the row sees, and it is NULL for exactly as long as the attendance has no end — which
 * is a state to name rather than a zero to print.
 */
export function AttendanceCardDuration({ seconds }: AttendanceCardDurationProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (seconds === null || seconds === undefined) {
		return (
			<Tag
				color="emerald"
				withPing
			>
				{t("users.attendance_running")}
			</Tag>
		);
	}

	/** Render */
	return (
		<div className="v-stack gap-0.5 items-end">
			<p className="label">{t("users.attendance_duration")}</p>
			<p className="font-bold tabular-nums">
				{getCalculatedTimeEasyString(calculateTimeBySeconds(seconds))}
			</p>
		</div>
	);
}
